import { ConditionLayoutProps } from 'modules/queryBuilder/contexts';
import {
  ConditionActionButtons,
  ConditionLayoutWrapper,
  ConditionLayoutSubWrapper,
} from './ConditionLayout.styles';
import { CONDITION_LAYOUT_DATA_TEST } from './constants';

export const ConditionLayout = ({
  FieldSelect,
  ComparatorSelect,
  ValueInput,
  CastTypeSelect,
  AddCondition,
  Delete,
  Duplicate,
}: ConditionLayoutProps) => {
  return (
    <ConditionLayoutWrapper data-test={CONDITION_LAYOUT_DATA_TEST.conditionLayout}>
      <ConditionLayoutSubWrapper>
        {FieldSelect}
        {ComparatorSelect}
        {ValueInput}
        {!!CastTypeSelect && CastTypeSelect}
        <ConditionActionButtons data-test={CONDITION_LAYOUT_DATA_TEST.actionButtons}>
          {AddCondition}
          {Duplicate}
          {Delete}
        </ConditionActionButtons>
      </ConditionLayoutSubWrapper>
    </ConditionLayoutWrapper>
  );
};
